import { API_BASE_URL } from '../config';

export async function fetchEmployeeChatUnreadCount(email: string): Promise<number> {
  const res = await fetch(
    `${API_BASE_URL}/api/employee/chat/unread-count?email=${encodeURIComponent(email)}`
  );
  if (!res.ok) return 0;
  const data = await res.json();
  return typeof data.count === 'number' ? data.count : Number(data.count) || 0;
}
